// extracted by mini-css-extract-plugin
module.exports = {"VidWrapper":"VideoModal_VidWrapper__GujJb","Video":"VideoModal_Video__1O6Rb","Close":"VideoModal_Close__3k1DL"};